import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";

function PermissionList() {
  const token = localStorage.getItem("token");
  const [permissionData, setPermissionData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentPermission, setCurrentPermission] = useState({
    id: "",
    name: "",
  });

  const modalStyles = {
    display: "flex",
    position: "fixed",
    zIndex: 1000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
    width: "400px",
    maxWidth: "90%",
  };

  const inputStyles = {
    margin: "10px 0",
    padding: "8px",
    width: "100%",
    boxSizing: "border-box",
  };

  const getPermissions = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetPermissionDropdown", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPermissionData(response); // Adjust based on your API response structure
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const handleEdit = (id) => {
    const permission = permissionData.find((perm) => perm.id === id);
    setCurrentPermission(permission);
    setIsEditMode(true);
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this permission?"
    );
    if (confirmDelete) {
      const formdata = { id: id };
      try {
        await post(`UserAuthentication/DeletePermission`, formdata, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getPermissions(); // Refresh the permission list after deletion
      } catch (error) {
        console.error("Error deleting permission:", error);
      }
    } else {
      console.log("Deletion canceled.");
    }
  };

  const handleCreate = () => {
    setCurrentPermission({ id: "", name: "" });
    setIsEditMode(false);
    setModalOpen(true);
  };

  const handleSave = async () => {
    if (!currentPermission.name.trim()) {
      alert("Permission name is required.");
      return;
    }

    const saveId = currentPermission.id ? currentPermission.id : 0;
    console.log(saveId);
    const formdata = {
      id: saveId,
      name: currentPermission.name,
    };
    try {
      await post(`UserAuthentication/AddUpdatePermission`, formdata, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalOpen(false);
      getPermissions(); // Refresh the permission list after save
    } catch (error) {
      console.error("Error saving permission:", error);
    }
  };

  useEffect(() => {
    getPermissions();
  }, []);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: false,
    },
    {
      name: "Permission Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            className="btn btn-outline-primary py-1 px-2 lh-2"
            onClick={() => handleEdit(row.id)}
          >
            Edit
          </button>
          <button
            className="btn btn-outline-danger py-1 px-2 lh-2"
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <button className="btn btn-outline-primary" onClick={handleCreate}>
        Create Permission
      </button>

      <DataTable columns={columns} data={permissionData} pagination dense />

      {modalOpen && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h2>{isEditMode ? "Edit Permission" : "Create Permission"}</h2>
            <div>
              <label>ID:</label>
              <input
                type="text"
                value={currentPermission.id}
                readOnly
                style={inputStyles}
              />
            </div>
            <div>
              <label>Name:</label>
              <input
                type="text"
                value={currentPermission.name}
                onChange={(e) =>
                  setCurrentPermission({
                    ...currentPermission,
                    name: e.target.value,
                  })
                }
                style={inputStyles}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={handleSave}
                className="btn btn-outline-success"
                style={{ marginRight: "10px" }}
              >
                Save
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn btn-outline-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PermissionList;
